/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "padlock-unlocked-0a4c744c--sprite",
  "use": "padlock-unlocked-0a4c744c--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"padlock-unlocked-0a4c744c--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><path d=\"M-68.027,130.45h-9.757v-2.218a3.866,3.866,0,0,1,3.569-3.917,3.753,3.753,0,0,1,3.759,2.61.745.745,0,0,0,.71.522h0a.756.756,0,0,0,.712-.994,5.249,5.249,0,0,0-5.413-3.629,5.388,5.388,0,0,0-4.838,5.437v2.188h-.75a.752.752,0,0,0-.751.75v8.886a.738.738,0,0,0,.735.736h12.024a.738.738,0,0,0,.75-.728V131.2A.757.757,0,0,0-68.027,130.45Zm-4.916,5.509a.2.2,0,0,0-.037.045,1.3,1.3,0,0,1-.3.233v.953a.753.753,0,0,1-.751.751.748.748,0,0,1-.75-.751v-.953a1.486,1.486,0,0,1-.751-1.3,1.456,1.456,0,0,1,.443-1.058A1.479,1.479,0,0,1-73,133.865c.007.008.015.015.023.015A1.47,1.47,0,0,1-72.943,135.959Z\" transform=\"translate(92.038 -114.707)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
